import { getFileExtension } from '../../../lib/analytics';

const EXTEND_ARTIFACT_PREVIEW_PROVIDER = {
  id: 'extend',
  label: 'Extend',
  supportedExtensions: ['docx', 'pdf', 'txt', 'xlsx'],
} as const;

const DOCMENTIS_ARTIFACT_PREVIEW_PROVIDER = {
  id: 'docmentis',
  label: 'docMentis',
  supportedExtensions: ['pptx'],
} as const;

const ARTIFACT_PREVIEW_PROVIDERS = [EXTEND_ARTIFACT_PREVIEW_PROVIDER, DOCMENTIS_ARTIFACT_PREVIEW_PROVIDER] as const;

export type ArtifactPreviewProviderId = (typeof ARTIFACT_PREVIEW_PROVIDERS)[number]['id'];

export type ArtifactPreviewFileType =
  | (typeof EXTEND_ARTIFACT_PREVIEW_PROVIDER.supportedExtensions)[number]
  | (typeof DOCMENTIS_ARTIFACT_PREVIEW_PROVIDER.supportedExtensions)[number];

export interface ArtifactPreview {
  fileType: ArtifactPreviewFileType;
  fileUrl: string;
  providerLabel: string;
  sourceUrl: string;
  title: string;
}

export interface ArtifactPreviewMenuItem {
  fileType: ArtifactPreviewFileType;
  filename: string;
  id: string;
  messageUuid?: string;
  providerId: ArtifactPreviewProviderId;
  providerLabel: string;
  source: string;
  uuid: string;
}

export function getArtifactPreviewFileType(filename: string): ArtifactPreviewFileType | undefined {
  const extension = getFileExtension(filename);
  if (!extension) return undefined;

  const supportedExtensions = ARTIFACT_PREVIEW_PROVIDERS.flatMap((provider) => provider.supportedExtensions);

  return (supportedExtensions as readonly string[]).includes(extension)
    ? (extension as ArtifactPreviewFileType)
    : undefined;
}

function getArtifactPreviewProvider(fileType: ArtifactPreviewFileType) {
  return ARTIFACT_PREVIEW_PROVIDERS.find((candidate) =>
    (candidate.supportedExtensions as readonly string[]).includes(fileType),
  );
}

export function getArtifactPreviewProviderLabel(fileType: ArtifactPreviewFileType): string {
  const provider = getArtifactPreviewProvider(fileType);

  return provider?.label ?? EXTEND_ARTIFACT_PREVIEW_PROVIDER.label;
}

export function getArtifactPreviewProviderId(fileType: ArtifactPreviewFileType): ArtifactPreviewProviderId {
  const provider = getArtifactPreviewProvider(fileType);

  return provider?.id ?? EXTEND_ARTIFACT_PREVIEW_PROVIDER.id;
}
